<form class="flex flex-1" [formGroup]="outreachTemplateSelectForm">
  <mat-form-field class="flex flex-1">
    <mat-label data-test-id="outreach-template-select-label">Template</mat-label>
    <input
      type="text"
      matInput
      formControlName="templateId"
      data-test-id="outreach-template-select-input"
      [matAutocomplete]="auto"
    />
    <mat-autocomplete #auto="matAutocomplete" [autoActiveFirstOption]="true" [displayWith]="displayFn(templates)">
      @if (all && all.length) {
        @if (favorites.length) {
          <mat-optgroup>
            <p class="text-xs font-bold">My favorites</p>
            @for (favorite of favorites; track favorite) {
              <mat-option data-test-id="outreach-template-select-option" [value]="favorite.templateId">
                <ng-container [ngTemplateOutlet]="templateOption" [ngTemplateOutletContext]="{ template: favorite }" />
              </mat-option>
            }
          </mat-optgroup>
        }

        @if (suggested.length) {
          <mat-optgroup>
            <p class="text-xs font-bold">Techspert suggested</p>
            @for (suggestedTemplate of suggested; track suggestedTemplate) {
              <mat-option data-test-id="outreach-template-select-option" [value]="suggestedTemplate.templateId">
                <ng-container
                  [ngTemplateOutlet]="templateOption"
                  [ngTemplateOutletContext]="{ template: suggestedTemplate }"
                />
              </mat-option>
            }
          </mat-optgroup>
        }

        @for (template of all; track template) {
          <mat-option data-test-id="outreach-template-select-option" [value]="template.templateId">
            <ng-container [ngTemplateOutlet]="templateOption" [ngTemplateOutletContext]="{ template: template }" />
          </mat-option>
        }
      } @else {
        <app-spinner size="sm" matSuffix class="mx-2" />
      }
    </mat-autocomplete>
    <mat-error data-test-id="outreach-template-select-option-error">Required</mat-error>
  </mat-form-field>
</form>

<ng-template #templateOption let-template="template">
  <div class="flex flex-row gap-3">
    <p data-test-id="outreach-template-select-option-name">
      {{ template.name }}
    </p>
    <div
      class="flex flex-row gap-1 flex-wrap"
      data-test-id="outreach-template-select-option-tags"
      [matTooltip]="template.tagTooltipText"
    >
      @for (tag of template.displayTags; track tag) {
        <span
          class="bg-[#228cdb] rounded-[0.25rem] py-1 px-2 text-xs text-white font-bold"
          data-test-id="outreach-template-select-option-tag"
        >
          {{ tag }}
        </span>
      }
    </div>
  </div>
</ng-template>
